import { render } from "./logos.vue?vue&type=template&id=40eafa36&scoped=true&lang=pug"
import script from "./logos.vue?vue&type=script&lang=js"
export * from "./logos.vue?vue&type=script&lang=js"

import "./logos.vue?vue&type=style&index=0&id=40eafa36&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eafa36"]])

export default __exports__